module.exports = "<svg style=\"width: 16px; height: 16px;\" x=\"0px\" y=\"0px\" viewBox=\"0 0 100 100\"><circle fill=\"#000\" cx=\"50\" cy=\"50\" r=\"50\"></circle></svg>"


//////////////////
// WEBPACK FOOTER
// ./assets/icons/circle.svg
// module id = 261
// module chunks = 0